import { ICalendarWeeksState } from '../types';
import { getWeeksByMonth } from './getWeeksByMonth';
import { getWeeksToPrepend } from './getWeeksToPrepend';
import { getWeeksToAppend } from './getWeeksToAppend';

export const buildInitialWeeks = (unix: number, timezone: string): ICalendarWeeksState => {
  const currentMonthWeeks = getWeeksByMonth(unix, timezone);
  const weeksToPrepend = getWeeksToPrepend(currentMonthWeeks, 5, timezone);
  const weeksToAppend = getWeeksToAppend(currentMonthWeeks, 5, timezone);

  const addedWeekKeysMap: Record<string, true> = {};

  const weeks = [
    ...weeksToPrepend,
    ...currentMonthWeeks,
    ...weeksToAppend,
  ];

  for (let weekIndex = 0; weekIndex < weeks.length; weekIndex += 1) {
    addedWeekKeysMap[weeks[weekIndex].weekKey] = true;
  }

  return {
    weeks,
    addedWeekKeysMap,
  };
};
